// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__WF4xf","footer":"ModalFilter_footer__1aYhB"};